import {AuthorizationStatus, Configs, PaymentChannel, Translations} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {
  AjaxNg1,
  EditDialogKnownActions
} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
export class ProService {
  constructor(ajax, $http, $q, $rootScope, $location, sessionService, onboardingService, uiHelpers, serviceModels, $window, $timeout, naviService) {
    this.ajax = ajax;
    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.sessionService = sessionService;
    this.onboardingService = onboardingService;
    this.uiHelpers = uiHelpers;
    this.serviceModels = serviceModels;
    this.$window = $window;
    this.$timeout = $timeout;
    this.naviService = naviService;
    this.comparisonViews = {
      ir: Translations.get("SALAXY.PRO.ProComparsionViews.ir"),
      usecase: Translations.get("SALAXY.PRO.ProComparsionViews.usecase"),
      calcs: Translations.get("SALAXY.PRO.ProComparsionViews.calcs"),
      worker: Translations.get("SALAXY.PRO.ProComparsionViews.worker"),
      salarySlip: Translations.get("SALAXY.PRO.ProComparsionViews.salarySlip"),
      employerReport: Translations.get("SALAXY.PRO.ProComparsionViews.employerReport"),
      paymentReport: Translations.get("SALAXY.PRO.ProComparsionViews.paymentReport")
    };
    this.currentComparisonView = "salarySlip";
    this.hourlyReports = [];
    this.tokenCache = {};
    this.isInitCalled = false;
    this.isInitReady = false;
    if (sessionService.isSessionChecked && sessionService.isAuthenticated) {
      this.init();
    }
    sessionService.onAuthenticatedSession($rootScope, () => {
      this.init();
    });
  }
  login() {
    this.addHourlyReportLog(null);
    this.sessionService.signIn();
  }
  logout() {
    this.addHourlyReportLog(null);
    this.sessionService.signOut();
  }
  getNavigationPath() {
    return this.$location.path();
  }
  setAccount(account, url = null) {
    this.account = account;
    if (account.id == this.session.currentAccount.id) {
      this.naviService.updateSitemapInRole();
      if (url) {
        this.naviService.navigateTo(url);
      }
      return Promise.resolve();
    }
    this.addHourlyReportLog(account);
    return this.getToken(account.id).then((cachedToken) => {
      this.naviService.updateSitemapInRole(cachedToken.session, this.sessionService.getAppStatus());
      return this.ensureListenerState("palkkausIframe").then((element) => {
        if (element) {
          element.contentWindow.postMessage({path: url, accountId: account.id, token: cachedToken.token, credentials: this.credentials, language: Translations.getLanguage()});
          return this.ensureListenerAccount("palkkausIframe", account.id).then(() => {
            if (url) {
              this.naviService.navigateTo(url);
              return;
            }
          });
        }
        return;
      });
    });
  }
  selectId(accountId, url = null) {
    const account = this.accounts.find((x) => x.id === accountId);
    if (!account) {
      throw new Error("Account id not found: " + (accountId || "null/empty"));
    }
    this.setAccount(account, url);
  }
  addHourlyReportLog(account) {
    if (!this.isInRole("test")) {
      return;
    }
    if (this.hourlyReports.length > 0) {
      this.hourlyReports[this.hourlyReports.length - 1].end = new Date();
    }
    this.hourlyReports.push({
      account: account ? account.avatar : null,
      start: new Date(),
      end: null
    });
  }
  checkAccountIsReady() {
    if (!this.account) {
      return false;
    }
    return true;
  }
  get isSessionChecking() {
    return this.sessionService.isSessionChecking;
  }
  getUrlWithToken(accountId, url) {
    return this.getToken(accountId).then((cachedToken) => {
      if (url.startsWith(window.salaxy.config.wwwServer)) {
        return url + "?access_token=" + encodeURIComponent(cachedToken.token);
      } else {
        return url + "#access_token=" + encodeURIComponent(cachedToken.token);
      }
    });
  }
  launchCompanyWizard(accountId = null) {
    return this.onboardingService.launchCustomerOnboarding(accountId).then(() => {
      return this.refreshCustomers();
    });
  }
  async changeAccountPartner(accountId, serviceModelId, action = "add") {
    const model = {
      action,
      serviceModelId: this.getServiceModels().find((x) => x.id == (serviceModelId || this.session.currentAccount.id))?.id
    };
    const dialog = await this.uiHelpers.openEditDialog("/views/pro/modals/changeAccountPartner.html", model, {});
    if (dialog.action != EditDialogKnownActions.Ok) {
      return;
    }
    const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"));
    let savedAccount;
    if (action === "remove") {
      savedAccount = await this.remove("pro/accounts/" + accountId + "/partner");
    } else {
      savedAccount = await this.postJSON("pro/accounts/" + accountId + "/partner?serviceModelId=" + (dialog.item.serviceModelId ? dialog.item.serviceModelId : ""), null);
    }
    loading.dismiss();
    if (!savedAccount?.id) {
      return;
    }
    let ix = this.accounts.findIndex((x) => x.id == savedAccount.id);
    if (ix >= 0) {
      this.accounts[ix] = savedAccount;
    }
    ix = this.customers.findIndex((x) => x.id == savedAccount.id);
    if (ix >= 0) {
      this.customers[ix] = savedAccount;
    }
  }
  deleteAccount(accountId) {
    this.uiHelpers.showConfirm(Translations.get("SALAXY.PRO.ProService.deleteAccountConfirm")).then((result) => {
      if (result) {
        const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"));
        this.ajax.remove("/accounts/authorizingAccount/" + accountId).then(() => {
          return this.getJSON("pro/accounts").then((accounts) => {
            this.accounts = accounts;
            this.setCustomers();
            return this.accounts;
          }).then(() => {
            loading.dismiss();
          });
        });
      }
    });
  }
  isInRole(role) {
    return this.sessionService.isInRole(role);
  }
  getToken(accountId) {
    const cached = this.getCachedToken(accountId);
    if (cached.state === "ready") {
      return Promise.resolve(cached);
    }
    return this.fetchToken(accountId);
  }
  getJSON(method) {
    return this.ajax.getJSON(this.getProApiMethod(method));
  }
  postJSON(method, data) {
    return this.ajax.postJSON(this.getProApiMethod(method), data);
  }
  remove(method) {
    return this.ajax.remove(this.getProApiMethod(method));
  }
  getSessionFor(ownerId) {
    const account = this.accounts.find((x) => x.id === ownerId);
    if (!account) {
      return null;
    }
    return {
      avatar: account.avatar,
      currentAccount: account,
      currentCredential: this.session.currentCredential,
      hasCredential: this.session.hasCredential,
      hasCurrentAccount: true,
      isAuthorized: true,
      settings: null,
      status: AuthorizationStatus.OK,
      systemAlertHtml: null
    };
  }
  async getAjaxFor(ownerId) {
    const cachedToken = await this.getToken(ownerId);
    const ajax = new AjaxNg1(this.$http, this.$q, {useCookie: false});
    ajax.setCurrentToken(cachedToken.token);
    return ajax;
  }
  getJSONFor(ownerId, method) {
    return this.getAjaxFor(ownerId).then((ajax) => {
      return ajax.getJSON(method);
    });
  }
  postJSONFor(ownerId, method, data) {
    return this.getAjaxFor(ownerId).then((ajax) => {
      return ajax.postJSON(method, data);
    });
  }
  removeFor(ownerId, method) {
    return this.getAjaxFor(ownerId).then((ajax) => {
      return ajax.remove(method);
    });
  }
  downloadFor(ownerId, method, data, responseType) {
    return this.$q.resolve(this.getToken(ownerId)).then((cachedToken) => {
      const request = {};
      request.headers = {Authorization: "Bearer " + cachedToken.token};
      request.url = window.salaxy.config.apiServer + method;
      request.method = "POST";
      request.data = data;
      request.responseType = responseType;
      request.withCredentials = false;
      return this.$http(request).then((response) => response.data, (error) => {
        return null;
      });
    });
  }
  getOwnedPaymentChannel() {
    return this.sessionService.getOwnedPaymentChannel();
  }
  getServiceModels() {
    if (!this.serviceModelsCache) {
      this.serviceModels.getOData({}).then((result) => {
        this.serviceModelsCache = result.items;
      });
      this.serviceModelsCache = [];
    }
    return this.serviceModelsCache;
  }
  clearServiceModelsCache() {
    this.serviceModelsCache = null;
  }
  getIdFromPath() {
    const path = this.$location.path();
    const getCrudItemId = (prefix) => {
      if (path.startsWith(prefix)) {
        return path.substring(prefix.length);
      }
      return "";
    };
    const crudItemId = getCrudItemId("/calc/details/") || getCrudItemId("/taxcards/details/");
    if (crudItemId) {
      let crudItemIdArr = crudItemId.split("/");
      crudItemIdArr = crudItemIdArr.map((x) => x ? x.replace(/[?&#](.*)/g, "") : x);
      return crudItemIdArr[0] || null;
    }
    return null;
  }
  refreshCustomers() {
    if (this.session && this.session.isAuthorized) {
      return this.getJSON("pro/accounts").then((accounts) => {
        this.accounts = accounts;
        if (this.accounts && this.accounts.length > 0) {
          this.account = this.accounts[0];
        }
        this.setCustomers();
        return this.accounts;
      });
    } else {
      this.accounts = [];
      this.setCustomers();
      return Promise.resolve(this.accounts);
    }
  }
  init() {
    if (this.isInitCalled) {
      return;
    }
    this.isInitCalled = true;
    this.session = null;
    this.accounts = null;
    this.account = null;
    this.customers = null;
    return this.getJSON("pro/session").then((session) => {
      this.session = session;
      if (this.session.settings.partnerMessages) {
        this.sessionService.clientRoles = this.sessionService.clientRoles.concat("proPartnerMessaging");
      }
      this.sessionService.clientRoles = this.sessionService.clientRoles.concat("partner");
      if (this.session.currentAccount.id === "FI30PRYR0002136294") {
        this.sessionService.clientRoles.push("householdService");
      }
      if (this.session.currentAccount.id === "FI08POYB0029041068") {
        this.sessionService.clientRoles.push("assureWorkerAccount");
      }
      if (this.session.currentAccount.id === "FI03POYA0003689675" || this.session.currentAccount.id === "FI79POYA0009321679") {
        if (this.session.settings.partner.serviceModel.features.forms) {
          this.sessionService.clientRoles = this.sessionService.clientRoles.concat("proPartnerService");
        }
        this.sessionService.clientRoles.push("accountorGo");
      } else if (this.session.currentAccount.id === "FI15POYA0008369224") {
        this.sessionService.clientRoles.push("finagoSolo");
      } else if (this.session.currentAccount.id === "FI06POYT0009439335") {
        this.sessionService.clientRoles.push("kevytyrittaja");
      }
      if (this.session.settings.paymentChannels.indexOf(PaymentChannel.PalkkausManual) >= 0) {
        this.sessionService.clientRoles.push("palkkausManual");
      } else if (this.session.currentAccount.id === "FI12POYT0005848481" || this.session.currentAccount.id === "FI28POYT0007918949" || this.session.currentAccount.id === "FI65POYA0021936684" || this.session.currentAccount.id === "FI96POYK0010259067" || this.session.currentAccount.id === "FI28POYT0021029275" || this.session.currentAccount.id === "FI29POYT0009637286" || this.session.currentAccount.id === "FI87POYK0024326945" || this.session.currentAccount.id === "FI08POYB0029041068" || this.session.currentAccount.id === "FI89PYYP0029105033" || this.session.currentAccount.id === "FI41PTMA0031744248" || this.session.currentAccount.id === "FI05POYO0019424778" || this.session.currentAccount.id === "FI53PYYE0014814240" || this.session.currentAccount.id === "FI52PTMT0017514286" || this.session.currentAccount.id === "FI76PYYA0008148958" || this.session.currentAccount.id === "FI73POYL0027040723" || this.session.currentAccount.id === "FI52POYC0025241513" || this.session.currentAccount.id === "FI14POYK0007079428" || this.session.currentAccount.id === "FI69POYE0009446017" || this.session.currentAccount.id === "FI36POYO0020747494" || this.session.currentAccount.id === "FI50POYT0031171005" || this.session.currentAccount.id === "FI02POYM0031806883" || this.session.currentAccount.id === "FI56POYT0007920870" || this.session.currentAccount.id === "FI45POYT0030923842" || this.session.currentAccount.id === "FI20POYL0031724837" || this.session.currentAccount.id === "FI58POYT0027846671" || this.session.currentAccount.id === "FI72POYV0023478314" || this.session.currentAccount.id === "FI42POYT0025991058" || Configs.current?.isTestData && this.session.currentAccount.id === "FI47POYT0046821621") {
        this.sessionService.clientRoles.push("palkkausManual");
      }
      this.naviService.updateSitemapInRole();
      return;
    }).then(() => {
      return this.refreshCustomers();
    }).then(() => {
      if (this.session && this.session.isAuthorized) {
        return this.getJSON("pro/credentials").then((credentials) => {
          this.credentials = credentials;
          return;
        });
      } else {
        this.credentials = [];
        return;
      }
    }).then(() => {
      this.isInitReady = true;
      return;
    });
  }
  setCustomers() {
    if (this.accounts && this.session && this.session.currentAccount) {
      this.customers = this.accounts.filter((x) => x.id !== this.session.currentAccount.id);
    }
  }
  getProApiMethod(method) {
    return "/v01/api/" + method;
  }
  fetchToken(accountId) {
    const cached = this.getCachedToken(accountId);
    cached.state = "pending";
    return this.getJSON("pro/accounts/" + accountId + "/token").then((token) => {
      if (token && token.indexOf('"') > 0) {
        console.debug("IE!!!");
        token = JSON.parse(token);
      }
      cached.token = token;
      return token;
    }).then((token) => {
      const ajax = new AjaxNg1(this.$http, this.$q, {useCookie: false});
      ajax.setCurrentToken(token);
      return ajax.getJSON("/session/current").then((session) => {
        cached.session = session;
        cached.state = "ready";
        return cached;
      });
    });
  }
  getCachedToken(accountId) {
    let cached = this.tokenCache[accountId];
    if (!cached) {
      this.tokenCache[accountId] = {token: null, session: null, state: "initial"};
      cached = this.tokenCache[accountId];
    }
    return cached;
  }
  ensureListenerState(id) {
    return new Promise((resolve) => {
      const check = () => {
        const element = this.$window.document.getElementById(id);
        if (element) {
          const messageListenerState = element.contentDocument.getElementById("messageListenerState");
          if (messageListenerState && messageListenerState.textContent == "OK") {
            return resolve(element);
          }
        }
        this.$timeout(() => check(), 50);
      };
      check();
    });
  }
  ensureListenerAccount(id, accountId) {
    return new Promise((resolve) => {
      const check = () => {
        const element = this.$window.document.getElementById(id);
        if (element) {
          const messageListenerAccount = element.contentDocument.getElementById("messageListenerAccount");
          if (messageListenerAccount && messageListenerAccount.textContent == accountId) {
            return resolve(element);
          }
        }
        this.$timeout(() => check(), 20);
      };
      check();
    });
  }
}
ProService.$inject = [
  "AjaxNg1",
  "$http",
  "$q",
  "$rootScope",
  "$location",
  "SessionService",
  "OnboardingService",
  "UiHelpers",
  "ServiceModels",
  "$window",
  "$timeout",
  "NaviService"
];
